const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000';

export const registrarEntradaInventario = async (data) => {
  try {
    const response = await fetch(`${API_URL}/movimientos-lenceria/registrar-entrada`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      throw new Error('Error al registrar entrada');
    }

    return await response.json();
  } catch (error) {
    console.error('Error en registrarEntradaInventario:', error);
    throw error;
  }
};

export const fetchMovimientos = async (filters = {}) => {
  try {
    const response = await fetch(`${API_URL}/movimientos-lenceria/filter`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(filters),
    });

    if (!response.ok) {
      throw new Error('Error al obtener movimientos');
    }

    return await response.json();
  } catch (error) {
    console.error('Error en fetchMovimientos:', error);
    throw error;
  }
};

export const fetchInventarioActual = async (filters = {}) => {
  try {
    const response = await fetch(`${API_URL}/movimientos-lenceria/inventario/filter`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(filters),
    });

    if (!response.ok) {
      throw new Error('Error al obtener inventario actual');
    }

    return await response.json();
  } catch (error) {
    console.error('Error en fetchInventarioActual:', error);
    throw error;
  }
};

export const recalcularInventario = async () => {
  try {
    const response = await fetch(`${API_URL}/movimientos-lenceria/recalcular-inventario`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error('Error al recalcular inventario');
    }

    return await response.json();
  } catch (error) {
    console.error('Error en recalcularInventario:', error);
    throw error;
  }
};

export const fetchMovimientoById = async (id) => {
  try {
    const response = await fetch(`${API_URL}/movimientos-lenceria/${id}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error('Error al obtener movimiento');
    }

    return await response.json();
  } catch (error) {
    console.error('Error en fetchMovimientoById:', error);
    throw error;
  }
};

export const fetchStockByIds = async (ids) => {
  try {
    const response = await fetch(`${API_URL}/inventario-lenceria-global/stock-by-ids`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ ids }),
    });

    if (!response.ok) {
      throw new Error('Error al obtener stock');
    }

    return await response.json();
  } catch (error) {
    console.error('Error en fetchStockByIds:', error);
    throw error;
  }
};

export const fetchStockByNames = async (nombres) => {
  try {
    const response = await fetch(`${API_URL}/inventario-lenceria-global/stock-by-names`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ nombres }),
    });

    if (!response.ok) {
      throw new Error('Error al obtener stock');
    }

    return await response.json();
  } catch (error) {
    console.error('Error en fetchStockByNames:', error);
    throw error;
  }
};

export const registrarRecoleccion = async (data) => {
  try {
    const response = await fetch(`${API_URL}/movimientos-lenceria/registrar-recoleccion`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Error al registrar recolección');
    }

    return await response.json();
  } catch (error) {
    console.error('Error en registrarRecoleccion:', error);
    throw error;
  }
};

export const fetchRecoleccionesPendientes = async (filters = {}) => {
  try {
    const response = await fetch(`${API_URL}/movimientos-lenceria/recolecciones-pendientes`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(filters),
    });

    if (!response.ok) {
      throw new Error('Error al obtener recolecciones pendientes');
    }

    return await response.json();
  } catch (error) {
    console.error('Error en fetchRecoleccionesPendientes:', error);
    throw error;
  }
};

export const confirmarRecoleccion = async (data) => {
  try {
    const response = await fetch(`${API_URL}/movimientos-lenceria/confirmar-recoleccion`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Error al confirmar recolección');
    }

    return await response.json();
  } catch (error) {
    console.error('Error en confirmarRecoleccion:', error);
    throw error;
  }
};
